import React from 'react'
import PropTypes from 'prop-types'

import Dialog from 'material-ui/Dialog'
import FlatButton from 'material-ui/FlatButton'
import CircularProgress from 'material-ui/CircularProgress'
import Utils from '../infra/Utils'

export default class DuplicateBillDialog extends React.Component {

  static propTypes = {
    open: PropTypes.bool.isRequired,
    billingEntity: PropTypes.string.isRequired,
    status: PropTypes.string,
    onCloseRequested: PropTypes.func.isRequired
  }
 
  handleCloseRequested = () => {
    if (this.props.status !== 'duplicating') {
      this.props.onCloseRequested()
    }
  }

  render() {
    if (!this.props.open) {
      return null
    }
    let content
    if (this.props.status === 'duplicating') {
      content = <div style={styles.progress}>
        <CircularProgress thickness={2} />
        <div style={styles.message}>Processing</div>
      </div>
    }
    else {
      content = <div style={styles.progress}>
        <i className='material-icons' style={styles.clear}>clear</i>
        <div style={styles.message}>{`An error occurred while duplicating your ${this.props.billingEntity}.`}</div>
      </div>
    }
    const disabled = this.props.status === 'duplicating'
    return (
      <Dialog open={this.props.open}
        onRequestClose={this.props.onCloseRequested}
        modal={true}
        actions={
          <div style={styles.actions}>
            <FlatButton
              label='Close'
              style={{ cursor: disabled ? 'not-allowed' : 'pointer' }}
              disabled={disabled}
              onTouchTap={this.handleCloseRequested} />
          </div>
        }
        title={`Duplicate this ${Utils.capitalize(this.props.billingEntity)}`}
        titleStyle={{ backgroundColor: '#fafafa' }}
        bodyStyle={styles.dialogBody}
        contentStyle={styles.dialogContent}
        actionsContainerStyle={{ padding: 0 }}>
        <div style={{ margin: 22 }}>
          { content }
        </div>
      </Dialog>
    )
  }

}

const styles = {
  dialogContent: {
    borderRadius: 4,
    // This is a hack as there is a bug in Dialog's definition to properly
    // apply the border radius.
    overflow: 'auto',
    width: 400
  },
  dialogBody: {
    display: 'flex',
    flexDirection: 'column',
    padding: 0,
    borderRadius: 4
  },
  progress: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center'
  },
  clear: {
    fontSize: 40,
    color: '#f00'
  },
  message: {
    marginTop: 32,
    fontSize: 16
  },
  actions: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'flex-end',
    alignItems: 'center',
    height: 48,
    paddingRight: 16,
    backgroundColor: '#fafafa'
  }
}



// WEBPACK FOOTER //
// ./src/billing/common/DuplicateBillDialog.js